export const navigation = {
  support: {
    question: "Need assistance?",
    whatsappCta: "Message us on WhatsApp",
  },
  alt: {
    whatsapp: "WhatsApp icon",
    logo: "Dashboard logo",
  },
};
